/**
 * Angular app bootstrapping
 */
import '../../src/recruiter_search/app/angular/init';
/**
 * Back to top button
 */
import { addBackToTop, DEFAULT_SETTINGS } from '../../src/components/back_to_top/back_to_top';
addBackToTop({...DEFAULT_SETTINGS, zIndex: 1000});
